module.exports = __webpack_public_path__ + "static/media/home-check-green.63d0c9b7.svg";